/**
 * 창 컴포넌트를 「값이 바뀔 때만 다시 그린다」 로 감싼다(2026-10-22 — 작업 탭 전환 지연).
 *
 * 창을 그리는 쪽(Header)은 작업 탭을 바꿀 때마다 다시 그려지고 onClose 같은 콜백을 매번 새 함수로 넘긴다. 그러면
 * 창 본문(오라클 성능 분석 · 세션 분석 …)이 통째로 다시 그려져 탭을 오갈 때마다 100ms 넘게 멈췄다.
 * 여기서는 함수 props 를 **늘 같은 대리 함수**로 바꿔 넘기고(부르면 그때의 최신 함수를 부른다), 나머지 값은
 * React.memo 의 얕은 비교에 맡긴다 — 값이 실제로 바뀌면 그대로 다시 그린다.
 */
import React, { useRef } from 'react';

export default function memoWindow(Component) {
    const Inner = React.memo(Component);
    function MemoWindow(props) {
        const latest = useRef(props);
        latest.current = props;
        const proxies = useRef({});
        const out = {};
        Object.keys(props).forEach((k) => {
            if (typeof props[k] === 'function') {
                if (!proxies.current[k]) proxies.current[k] = (...args) => {
                    const fn = latest.current[k];
                    return typeof fn === 'function' ? fn(...args) : undefined;
                };
                out[k] = proxies.current[k];
            } else {
                out[k] = props[k];
            }
        });
        return <Inner {...out} />;
    }
    MemoWindow.displayName = `memoWindow(${Component.displayName || Component.name || 'Window'})`;
    return MemoWindow;
}
